import type { FormikConfig } from 'formik';

export interface JoinShelterPageFormValues {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export interface JoinShelterPageData {
  form: {
    validationSchema: any;
    initialValues: JoinShelterPageFormValues;
    onSubmit: FormikConfig<JoinShelterPageFormValues>['onSubmit'];
  };
}

export interface JoinShelterPageProps extends JoinShelterPageData {}
